import { takeLatest, put, all, call } from 'redux-saga/effects';
import { adminAPI } from 'resources/api';
import { processError } from 'state/utils';
import Types from './types';

function* fetchStatsStartAsync() {
    try {
        const res = yield adminAPI.getStats();
        yield put({ type: Types.FETCH_STATS_SUCCESS, payload: res });
    } catch (error) {
        const message = processError(error);
        console.error(message);
        yield put({ type: Types.FETCH_STATS_ERROR, payload: message });
    }
}

function* fetchStatsStart() {
    yield takeLatest(Types.FETCH_STATS_START, fetchStatsStartAsync);
}

function* fetchUsersStartAsync({ payload }) {
    try {
        const res = yield adminAPI.getUsers(payload);
        yield put({ type: Types.FETCH_USERS_SUCCESS, payload: res });
    } catch (error) {
        const message = processError(error);
        console.error(message);
        yield put({ type: Types.FETCH_USERS_ERROR, payload: message });
    }
}

function* fetchUsersStart() {
    yield takeLatest(Types.FETCH_USERS_START, fetchUsersStartAsync);
}

function* fetchUserByIdStartAsync({ payload }) {
    try {
        const res = yield adminAPI.getUserById(payload);
        yield put({ type: Types.FETCH_USER_BY_ID_SUCCESS, payload: res });
    } catch (error) {
        const message = processError(error);
        console.error(message);
        yield put({ type: Types.FETCH_USER_BY_ID_ERROR, payload: message });
    }
}

function* fetchUserByIdStart() {
    yield takeLatest(Types.FETCH_USER_BY_ID_START, fetchUserByIdStartAsync);
}

function* approveTherapistStartAsync({ payload }) {
    try {
        const { id, data } = payload;
        yield adminAPI.approveTherapist(id, data);
        yield put({ type: Types.APPROVE_THERAPIST_SUCCESS, payload: {} });
        // Refrescar lista de pendientes
        yield put({ type: Types.FETCH_PENDING_THERAPISTS_START, payload: {} });
    } catch (error) {
        const message = processError(error);
        console.error(message);
        yield put({ type: Types.APPROVE_THERAPIST_ERROR, payload: message });
    }
}

function* approveTherapistStart() {
    yield takeLatest(Types.APPROVE_THERAPIST_START, approveTherapistStartAsync);
}

function* rejectTherapistStartAsync({ payload }) {
    try {
        const { id, reason } = payload;
        yield adminAPI.rejectTherapist(id, { reason });
        yield put({ type: Types.REJECT_THERAPIST_SUCCESS, payload: {} });
        // Refrescar lista de pendientes
        yield put({ type: Types.FETCH_PENDING_THERAPISTS_START, payload: {} });
    } catch (error) {
        const message = processError(error);
        console.error(message);
        yield put({ type: Types.REJECT_THERAPIST_ERROR, payload: message });
    }
}

function* rejectTherapistStart() {
    yield takeLatest(Types.REJECT_THERAPIST_START, rejectTherapistStartAsync);
}

function* fetchReviewsStartAsync({ payload }) {
    try {
        const res = yield adminAPI.getReviews(payload);
        yield put({ type: Types.FETCH_REVIEWS_SUCCESS, payload: res });
    } catch (error) {
        const message = processError(error);
        console.error(message);
        yield put({ type: Types.FETCH_REVIEWS_ERROR, payload: message });
    }
}

function* fetchReviewsStart() {
    yield takeLatest(Types.FETCH_REVIEWS_START, fetchReviewsStartAsync);
}

function* moderateReviewStartAsync({ payload }) {
    try {
        const { id, data } = payload;
        yield adminAPI.moderateReview(id, data);
        yield put({ type: Types.MODERATE_REVIEW_SUCCESS, payload: {} });
        // Refresh reviews list after moderation
        yield put({ type: Types.FETCH_REVIEWS_START, payload: {} });
    } catch (error) {
        const message = processError(error);
        console.error(message);
        yield put({ type: Types.MODERATE_REVIEW_ERROR, payload: message });
    }
}

function* moderateReviewStart() {
    yield takeLatest(Types.MODERATE_REVIEW_START, moderateReviewStartAsync);
}

function* updateUserStartAsync({ payload }) {
    try {
        const { id, data } = payload;
        const res = yield adminAPI.updateUser(id, data);
        yield put({ type: Types.UPDATE_USER_SUCCESS, payload: res });
        // Refresh users list
        yield put({ type: Types.FETCH_USERS_START, payload: {} });
    } catch (error) {
        const message = processError(error);
        console.error(message);
        yield put({ type: Types.UPDATE_USER_ERROR, payload: message });
    }
}

function* updateUserStart() {
    yield takeLatest(Types.UPDATE_USER_START, updateUserStartAsync);
}

function* deleteUserStartAsync({ payload }) {
    try {
        yield adminAPI.deleteUser(payload);
        yield put({ type: Types.DELETE_USER_SUCCESS, payload: {} });
        // Refresh users list
        yield put({ type: Types.FETCH_USERS_START, payload: {} });
    } catch (error) {
        const message = processError(error);
        console.error(message);
        yield put({ type: Types.DELETE_USER_ERROR, payload: message });
    }
}

function* deleteUserStart() {
    yield takeLatest(Types.DELETE_USER_START, deleteUserStartAsync);
}

function* toggleUserStatusStartAsync({ payload }) {
    try {
        yield adminAPI.toggleUserStatus(payload);
        yield put({ type: Types.TOGGLE_USER_STATUS_SUCCESS, payload: {} });
        yield put({ type: Types.FETCH_USERS_START, payload: {} });
    } catch (error) {
        const message = processError(error);
        console.error(message);
        yield put({ type: Types.TOGGLE_USER_STATUS_ERROR, payload: message });
    }
}

function* toggleUserStatusStart() {
    yield takeLatest(Types.TOGGLE_USER_STATUS_START, toggleUserStatusStartAsync);
}

function* resetUserPasswordStartAsync({ payload }) {
    try {
        const { id, newPassword } = payload;
        yield adminAPI.resetUserPassword(id, newPassword);
        yield put({ type: Types.RESET_USER_PASSWORD_SUCCESS, payload: {} });
    } catch (error) {
        const message = processError(error);
        console.error(message);
        yield put({ type: Types.RESET_USER_PASSWORD_ERROR, payload: message });
    }
}

function* resetUserPasswordStart() {
    yield takeLatest(Types.RESET_USER_PASSWORD_START, resetUserPasswordStartAsync);
}

function* fetchPendingTherapistsStartAsync() {
    try {
        const res = yield adminAPI.getPendingTherapists();
        yield put({ type: Types.FETCH_PENDING_THERAPISTS_SUCCESS, payload: res });
    } catch (error) {
        const message = processError(error);
        console.error(message);
        yield put({ type: Types.FETCH_PENDING_THERAPISTS_ERROR, payload: message });
    }
}

function* fetchPendingTherapistsStart() {
    yield takeLatest(Types.FETCH_PENDING_THERAPISTS_START, fetchPendingTherapistsStartAsync);
}

function* fetchTherapistsStartAsync({ payload }) {
    try {
        const res = yield adminAPI.getTherapists(payload);
        yield put({ type: Types.FETCH_THERAPISTS_SUCCESS, payload: res.data || res });
    } catch (error) {
        const message = processError(error);
        yield put({ type: Types.FETCH_THERAPISTS_FAIL, payload: message });
    }
}

function* fetchTherapistsStart() {
    yield takeLatest(Types.FETCH_THERAPISTS_START, fetchTherapistsStartAsync);
}

// ── Businesses ────────────────────────────────────────────────────────────────

function* fetchBusinessesStartAsync({ payload }) {
    try {
        const res = yield adminAPI.getBusinesses(payload);
        yield put({ type: Types.FETCH_BUSINESSES_SUCCESS, payload: res });
    } catch (error) {
        const message = processError(error);
        yield put({ type: Types.FETCH_BUSINESSES_ERROR, payload: message });
    }
}

function* fetchBusinessesStart() {
    yield takeLatest(Types.FETCH_BUSINESSES_START, fetchBusinessesStartAsync);
}

function* fetchBusinessByIdStartAsync({ payload }) {
    try {
        const res = yield adminAPI.getBusinessById(payload);
        yield put({ type: Types.FETCH_BUSINESS_BY_ID_SUCCESS, payload: res });
    } catch (error) {
        const message = processError(error);
        yield put({ type: Types.FETCH_BUSINESS_BY_ID_ERROR, payload: message });
    }
}

function* fetchBusinessByIdStart() {
    yield takeLatest(Types.FETCH_BUSINESS_BY_ID_START, fetchBusinessByIdStartAsync);
}

function* updateBusinessStartAsync({ payload }) {
    try {
        const { id, data } = payload;
        const res = yield adminAPI.updateBusiness(id, data);
        yield put({ type: Types.UPDATE_BUSINESS_SUCCESS, payload: res });
    } catch (error) {
        const message = processError(error);
        yield put({ type: Types.UPDATE_BUSINESS_ERROR, payload: message });
    }
}

function* updateBusinessStart() {
    yield takeLatest(Types.UPDATE_BUSINESS_START, updateBusinessStartAsync);
}

function* updateBusinessStatusStartAsync({ payload }) {
    try {
        const { id, status } = payload;
        yield adminAPI.updateBusinessStatus(id, status);
        yield put({ type: Types.UPDATE_BUSINESS_STATUS_SUCCESS, payload: {} });
        yield put({ type: Types.FETCH_BUSINESS_BY_ID_START, payload: id });
    } catch (error) {
        const message = processError(error);
        yield put({ type: Types.UPDATE_BUSINESS_STATUS_ERROR, payload: message });
    }
}

function* updateBusinessStatusStart() {
    yield takeLatest(Types.UPDATE_BUSINESS_STATUS_START, updateBusinessStatusStartAsync);
}

// ── Create / Delete / Bulk Businesses ────────────────────────────────────────

function* createBusinessStartAsync({ payload }) {
    try {
        const res = yield adminAPI.createBusiness(payload);
        yield put({ type: Types.CREATE_BUSINESS_SUCCESS, payload: res });
        yield put({ type: Types.FETCH_BUSINESSES_START, payload: {} });
    } catch (error) {
        const message = processError(error);
        yield put({ type: Types.CREATE_BUSINESS_ERROR, payload: message });
    }
}

function* createBusinessStart() {
    yield takeLatest(Types.CREATE_BUSINESS_START, createBusinessStartAsync);
}

function* deleteBusinessStartAsync({ payload }) {
    try {
        yield adminAPI.deleteBusiness(payload);
        yield put({ type: Types.DELETE_BUSINESS_SUCCESS, payload: {} });
        yield put({ type: Types.FETCH_BUSINESSES_START, payload: {} });
    } catch (error) {
        const message = processError(error);
        yield put({ type: Types.DELETE_BUSINESS_ERROR, payload: message });
    }
}

function* deleteBusinessStart() {
    yield takeLatest(Types.DELETE_BUSINESS_START, deleteBusinessStartAsync);
}

function* bulkDeleteBusinessesStartAsync({ payload }) {
    try {
        yield adminAPI.bulkDeleteBusinesses(payload);
        yield put({ type: Types.BULK_DELETE_BUSINESSES_SUCCESS, payload: {} });
        yield put({ type: Types.FETCH_BUSINESSES_START, payload: {} });
    } catch (error) {
        const message = processError(error);
        yield put({ type: Types.BULK_DELETE_BUSINESSES_ERROR, payload: message });
    }
}

function* bulkDeleteBusinessesStart() {
    yield takeLatest(Types.BULK_DELETE_BUSINESSES_START, bulkDeleteBusinessesStartAsync);
}

function* bulkUpdateBusinessStatusStartAsync({ payload }) {
    try {
        const { ids, status } = payload;
        yield adminAPI.bulkUpdateBusinessStatus(ids, status);
        yield put({ type: Types.BULK_UPDATE_BUSINESS_STATUS_SUCCESS, payload: {} });
        yield put({ type: Types.FETCH_BUSINESSES_START, payload: {} });
    } catch (error) {
        const message = processError(error);
        yield put({ type: Types.BULK_UPDATE_BUSINESS_STATUS_ERROR, payload: message });
    }
}

function* bulkUpdateBusinessStatusStart() {
    yield takeLatest(Types.BULK_UPDATE_BUSINESS_STATUS_START, bulkUpdateBusinessStatusStartAsync);
}

// ── User Bulk Actions ─────────────────────────────────────────────────────────

function* bulkDeleteUsersStartAsync({ payload }) {
    try {
        yield adminAPI.bulkDeleteUsers(payload);
        yield put({ type: Types.BULK_DELETE_USERS_SUCCESS, payload: {} });
        yield put({ type: Types.FETCH_USERS_START, payload: {} });
    } catch (error) {
        const message = processError(error);
        yield put({ type: Types.BULK_DELETE_USERS_ERROR, payload: message });
    }
}

function* bulkDeleteUsersStart() {
    yield takeLatest(Types.BULK_DELETE_USERS_START, bulkDeleteUsersStartAsync);
}

function* bulkToggleUsersStartAsync({ payload }) {
    try {
        const { ids, action } = payload;
        yield adminAPI.bulkToggleUsers(ids, action);
        yield put({ type: Types.BULK_TOGGLE_USERS_SUCCESS, payload: {} });
        yield put({ type: Types.FETCH_USERS_START, payload: {} });
    } catch (error) {
        const message = processError(error);
        yield put({ type: Types.BULK_TOGGLE_USERS_ERROR, payload: message });
    }
}

function* bulkToggleUsersStart() {
    yield takeLatest(Types.BULK_TOGGLE_USERS_START, bulkToggleUsersStartAsync);
}

function* hardDeleteUserStartAsync({ payload }) {
    try {
        yield adminAPI.hardDeleteUser(payload);
        yield put({ type: Types.HARD_DELETE_USER_SUCCESS, payload: {} });
        yield put({ type: Types.FETCH_USERS_START, payload: {} });
    } catch (error) {
        const message = processError(error);
        yield put({ type: Types.HARD_DELETE_USER_ERROR, payload: message });
    }
}

function* hardDeleteUserStart() {
    yield takeLatest(Types.HARD_DELETE_USER_START, hardDeleteUserStartAsync);
}

function* bulkHardDeleteUsersStartAsync({ payload }) {
    try {
        yield adminAPI.bulkHardDeleteUsers(payload);
        yield put({ type: Types.BULK_HARD_DELETE_USERS_SUCCESS, payload: {} });
        yield put({ type: Types.FETCH_USERS_START, payload: {} });
    } catch (error) {
        const message = processError(error);
        yield put({ type: Types.BULK_HARD_DELETE_USERS_ERROR, payload: message });
    }
}

function* bulkHardDeleteUsersStart() {
    yield takeLatest(Types.BULK_HARD_DELETE_USERS_START, bulkHardDeleteUsersStartAsync);
}

function* createUserStartAsync({ payload }) {
    try {
        const res = yield adminAPI.createUser(payload);
        yield put({ type: Types.CREATE_USER_SUCCESS, payload: res });
        yield put({ type: Types.FETCH_USERS_START, payload: {} });
    } catch (error) {
        const message = processError(error);
        console.error(message);
        yield put({ type: Types.CREATE_USER_ERROR, payload: message });
    }
}

function* createUserStart() {
    yield takeLatest(Types.CREATE_USER_START, createUserStartAsync);
}

function* restoreUserStartAsync({ payload }) {
    try {
        yield adminAPI.restoreUser(payload);
        yield put({ type: Types.RESTORE_USER_SUCCESS, payload: {} });
        yield put({ type: Types.FETCH_USERS_START, payload: {} });
    } catch (error) {
        const message = processError(error);
        console.error(message);
        yield put({ type: Types.RESTORE_USER_ERROR, payload: message });
    }
}

function* restoreUserStart() {
    yield takeLatest(Types.RESTORE_USER_START, restoreUserStartAsync);
}

export default function* sagas() {
    yield all([
        call(fetchStatsStart),
        call(fetchUsersStart),
        call(fetchUserByIdStart),
        call(updateUserStart),
        call(deleteUserStart),
        call(toggleUserStatusStart),
        call(resetUserPasswordStart),
        call(fetchPendingTherapistsStart),
        call(approveTherapistStart),
        call(rejectTherapistStart),
        call(fetchReviewsStart),
        call(moderateReviewStart),
        call(fetchBusinessesStart),
        call(fetchBusinessByIdStart),
        call(updateBusinessStart),
        call(updateBusinessStatusStart),
        call(createBusinessStart),
        call(deleteBusinessStart),
        call(bulkDeleteBusinessesStart),
        call(bulkUpdateBusinessStatusStart),
        call(bulkDeleteUsersStart),
        call(bulkToggleUsersStart),
        call(hardDeleteUserStart),
        call(bulkHardDeleteUsersStart),
        call(createUserStart),
        call(restoreUserStart),
        call(fetchTherapistsStart),
    ]);
}
